var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"/admin?tab=privateTransfers&status=Pending"}},[_c('v-alert',{attrs:{"outlined":"","type":"info"}},[_vm._v(_vm._s(_vm.pendingText))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }